import {Button} from '@/components/ui/button/Button'
import {StyledDateRangeFilterFooter} from './style'
import {useTranslation} from '@/translations/i18n'
import {usePopoverContext} from '@ariakit/react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useCallback} from 'react'

export const DateRangeFilterFooter = ({onApply, onClear}: {onApply: () => void; onClear?: () => void}) => {
    const {t} = useTranslation()
    const popover = usePopoverContext()
    const handleClear = useCallback(() => {
        onClear?.()
        popover?.setOpen(false)
    }, [onClear])
    return (
        <StyledDateRangeFilterFooter>
            <Button variant="ghost" onClick={() => popover?.hide()}>
                {t('commons:close')}
            </Button>

            <Flexbox gap={3}>
                {onClear && (
                    <Button variant="secondary" onClick={handleClear}>
                        {t('commons:remove_selection')}
                    </Button>
                )}
                <Button variant="primaryNeutral" onClick={onApply}>
                    {t('commons:apply')}
                </Button>
            </Flexbox>
        </StyledDateRangeFilterFooter>
    )
}
